import styled from 'styled-components';
import Button from '@gcc/pip-components/dist/Button';
import {
  mobileMaxWidth,
  desktopMinWidth,
  tablet,
  desktop,
  mobile
} from '../../utils/constants';

export const HorizontalLine = styled.hr`
  border-top: 0.2rem solid #d8d8d8;
  height: 0.5rem;
`;

export const AddStairCaseWrapper = styled.div`
  margin-top: 2.5rem;
  margin-bottom: 1.5rem;

  @media all and (min-width: ${desktop}) {
 }

  @media all and (max-width: 767px) and (min-width: ${tablet}) {
    width: 100%;
  }

  @media all and (max-width: 767px) and (min-width: ${mobile}) {
    margin-top: 0;
    width: 100%;
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export const StairTitleWrapper = styled.div`
font-weight: bold;
padding-top: 2.5rem;

@media all and (min-width: ${desktop}) {
 }

 @media all and (max-width: 1023px) and (min-width: ${tablet}) {

 }
 @media all and (max-width: 767px) and (min-width: ${mobile}) {
  padding-bottom: 2.5rem;

}
`;

export const AddStepButtonWrapper = styled.div`

@media all and (min-width: ${desktop}) {
  width: 200px;
}

@media all and (max-width: 1023px) and (min-width: ${tablet}) {
  width: 200px;
}
@media all and (max-width: 767px) and (min-width: ${mobile}) {
 width: 100%;
}

`;

export const Form = styled.form`
  display: flex;
  gap: 16px;
  @media all and (min-width: ${desktopMinWidth}) {

  }
  @media all and (min-width: ${tablet}) {

  }

  @media all and (max-width: ${mobileMaxWidth}) {
    flex-direction: column;
    width: 100%;
  }
`;

export const StairGrids = styled.div`
display: grid;

@media all and (min-width: ${desktop}) {
 grid-template-columns: repeat(3, 1fr);
 grid-auto-rows: minmax(180px, auto);
 gap: 16px;
}

@media all and (max-width: 1023px) and (min-width: ${tablet}) {
  width: 50%;
  text-align: left;
  grid-template-columns: repeat(1, 1fr);
  grid-auto-rows: minmax(180px, auto);
  gap: 16px;
}

@media all and (max-width: 767px) and (min-width: ${mobile}) {
  width: 100%;
  grid-template-columns: repeat(1, 1fr);
  grid-auto-rows: minmax(145px, auto);
  gap: 1.5rem;
}
`;

export const StepsButtonWrapper = styled.div`
  margin-top: 0.7rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;

  @media (max-width: ${mobileMaxWidth}) {
    max-width: 100%;
  }
`;

export const EditConfirmationWrapper = styled.div`
  margin-top: 0.7rem;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StairsButton = styled(Button)`
  &&& {
    background-color: #fff;
    color: #333333;
    text-decoration: none;
    text-align: center;
    height: 4rem;
    border: 0.2rem solid #333333;

    @media all and (min-width: ${desktopMinWidth}) {
      max-width: 28.5rem;
    }

    &:hover, &:visited, &:focus {
      background-color:#333333;
      color: #fff;
    }
  }
`;

export const StairsYesButton = styled(StairsButton)``;

export const StairsNoButton = styled(StairsButton)`
  &&& {
    background-color: ${({ isno }) => (isno ? '#333333' : '#fff')};
    color: ${({ isno }) => (isno ? '#fff' : '#333333')};
  }
`;

export const AddStepsButton = styled(Button)`
  background: #999;
  background-color: ${(props) => (props.isSave ? '#F96302 !important' : null)};
  margin-left: 1.2rem;
  max-width: 16rem;
  color: ${(props) => (props.isSave ? '#fff !important' : null)};
  text-decoration: none;
  flex-grow: 1;
  text-align: center;
  height: 4rem;
  font-weight: 600;
  padding-top: 0.1rem;

  @media (max-width: ${mobileMaxWidth}) {
    min-width: 100%;
    margin-left : 0;
    margin-top : 1.2rem;
  }
`;

export const StepsNumber = styled.input`
  border: 0.1rem solid #999999;
  height: 3.7rem;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  & > input {
    box-sizing: border-box;
    border-radius: 3px;
    padding: 0.2rem 0.5rem;
    height: 4rem;
  }

  @media (max-width: ${mobileMaxWidth}) {
    width: 100%;
  }
`;

export const ConfirmWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StepsLabel = styled.label`
  &&& {
    margin-right: 12rem;
  }
`;

export const LinkWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 4rem;
  align-items: flex-end;

  & > * {
    font-size: 1.4rem;
    margin: 1rem;
  }
`;

export const Paragraph = styled.p``;
